<template>
  <div class="content--sinoreg page--cadastroObito">
    <HeaderForSection class="mb-4"
                      :icone="7"
                      :data-inicio="dataInicio" />

    <PassoRegistro class="py-2"
                   :data="dados"
                   :read-only="true"
                   :legado="true"
                   @registroUpdated="updateRegistro" />

    <FalecidoLegado class="py-2"
                    :data="dados"
                    :read-only="true"
                    :prop-cartorio="dadosCartorio"
                    @changed="changed" />

    <PassoOutrasInfo class="py-2"
                     :data="dados"
                     :prop-legado="true"
                     :read-only="true"
                     :prop-cartorio="dadosCartorio"
                     @changed="changed"
                     @documentoRemoved="documentoRemoved"
                     @verifyParte="verifyParte" />

    <PassoDadosFalecimento class="py-2"
                           :data="dados"
                           :read-only="true"
                           :prop-validator="true"
                           :prop-cartorio="dadosCartorio"
                           :prop-legado="true"
                           @changed="changed" />

    <div class="cadastroObito_footer mb-2 border-top border-primary pt-3">
      <div class="row no-gutters justify-content-end align-items-center">
        <div class="d-inline-block">
          <b-link class="btn btn-sm btn-dark"
                  :to="{ name: 'rei_dashboard' }">
            Voltar
          </b-link>
        </div>

        <div class="d-inline-block ml-2">
          <button class="btn btn-sm btn-primary"
                  type="button"
                  @click="validateRegistro">
            Cadastrar Registro
          </button>
        </div>
      </div>
    </div>
    <b-modal v-if="rascunhoFound"
             id="modalRascunho"
             ref="modalRascunho"
             no-close-on-backdrop
             no-close-on-esc
             :visible="true"
             centered
             size="xl">
      <div slot="modal-header"
           class="modalGenitor_title w-100">
        Rascunho encontrado
      </div>
      <SearchRascunho :prop-rascunho="rascunhoFound"
                      :prop-segunda-via="true" />
      <div slot="modal-footer"
           slot-scope="{ ok, cancel }">
        <button class="btn btn-sm btn-primary"
                @click="() => { cancel(); newRascunho(); }">
          Continuar com o Cadastro
        </button>
      </div>
    </b-modal>
  </div>
</template>

<script>
/* components */
  import HeaderForSection from '@/components/SofiaRei/HeaderForSection.vue'
  import FalecidoLegado from '@/components/SofiaRei/Obito/SegundaVia/FalecidoLegado.vue'
  import PassoDadosFalecimento from '@/components/SofiaRei/Obito/Passos/PassoDadosFalecimento.vue'
  import PassoOutrasInfo from '@/components/SofiaRei/Obito/Passos/PassoOutrasInfo.vue'
  import PassoRegistro from '@/components/SofiaRei/Obito/Passos/PassoRegistro.vue'
  import SearchRascunho from "@/components/SofiaRei/Busca/SearchRascunho.vue"

  /* services */
  import RegistrosService from "@/services/Registros"
  import ObitoService from "@/services/Registros/Obito"
  import BuscaService from "@/services/BuscaService"

  /* constantes */
  import objSwal from '@/constants/swalValues'

  /* filters */
  import { filterMaskedNumber } from '@/filters/filters'

  /* others */
  import { mapGetters } from 'vuex'
  import Swal from "sweetalert2"
  import moment from "moment"

  export default {
    name: 'CadastroObito',
    components: {SearchRascunho, HeaderForSection, FalecidoLegado, PassoDadosFalecimento, PassoOutrasInfo, PassoRegistro },
    data () {
      return {
        natimorto: false,
        desconhecido: false,
        passoAtivo: 0,
        obito_id: null,
        dados: {
          pessoa: {},
          idade_tipo: null,
          genitores: [],
          medicos: [],
          documentos: [],
          filhoDeixado: [],
          registro: {
            anteriores: [],
            partes: [],
            tipo_registro: '',
            cartorio_id: this.$store.state.auth.cartorio_id
          },
          sexo: '',
          cor_pele: '',
          estado_civil: 'IGNORADO',
          causaObito: { tipo_morte: '' },
          nacionalidade: {
            codigo: 76,
            nome: "Brasil",
            nome_feminino: "brasileira",
            nome_masculino: "brasileiro",
          },
          sem_declaracao_obito: false,
          semanas_gestacao: false,
          qtd_gemeos: null

        },
        passos: [
          { texto: 'Falecido' },
          { texto: 'Dados do Falecimento' },
          { texto: 'Outras Informações' },
          { texto: 'Registro' }
        ],
        dadosCartorio: {},
        parte: {},
        dataInicio: '',
        showModalRascunho: false,
        rascunhoFound: null
      }
    },
    provide: function () {
      return {
        $validator: this.$validator
      }
    },
    computed: {
      ...mapGetters({
        cartorioId: 'auth/getCartorioId'
      }),
    },
    nextEnabled () {
      let disableIt = false

      if (this.dados.natimorto && !this.dados.nome) {
        this.dados.nome = 'SEM DESIGNAÇÃO DO NOME'
      }
      disableIt = !this.dados.nome

      return disableIt
    },
    async beforeCreate () {
      if (!!this.$route.params.id) {
        const { document, created_at } =  await RegistrosService.getRascunhoById(this.$route.params.id)
        const dados = !!document.registro.pessoa.nome ? document.registro.pessoa : document

        this.dados = {
          ...dados,
          rascunho_id: this.$route.params.id
        }
        this.dataInicio = created_at

        if (!this.dados) {
          await this.$router.push('/pagina-nao-encontrada')
        }

        if (this.obito && this.obito.obito_id) {
          return this.$router.push({ name: 'editar_obito', params: { id: this.obito.obito_id } })
        }
      }
    },
    mounted () {
      this.getCartorio()
    },
    methods: {
      async validateRegistro () {
        if (!this.validateCpfDuplicate()) return

        if (this.$route.params.id === 'novo') {
          return displayMessage('error', 'Acesso negado!', 'Você não tem permissão para acessar essa função.')
        }

        this.$validator.validate().then(resp => {
          if (resp && !this.nextEnabled) {
            const {pessoa, tipo} = this.parte

            if (pessoa && pessoa.nome && tipo === 'DECLARANTE') {
              this.dados.registro.partes.push(this.parte)
              this.parte = {}
            }

            return this.registerObito()
          } else {
            let invalids = document.querySelectorAll('.is-invalid')
            this.invalids(invalids)
          }
        })
      },

      validateCpfDuplicate () {
        if (this.dados.genitores) {
          const genitorComCpfFalecido = this.dados.genitores
            .filter((genitor) => {
              if (genitor.pessoa.cpf && this.dados.cpf) {
                return genitor.pessoa.cpf === filterMaskedNumber(this.dados.cpf)
              }
            })

          if (genitorComCpfFalecido.length) {
            objSwal.error.title = 'Erro ao cadastrar genitor'
            objSwal.error.text = `O CPF ${this.dados.cpf} já cadastrado para o falecido ${this.dados.nome}`
            Swal.fire(objSwal.error)

            return false
          }

          return true
        }
      },
      async searchRascunho (data) {
        this.dados.registro.tipo_registro = this.dados.natimorto ? 'NT' : 'O'
        this.rascunhoFound = await BuscaService.searchRascunhoBeforeSave(this.dados.registro, data)
        if (this.rascunhoFound) {
          this.showModalRascunho = true
        } else {
          this.newRascunho()
        }
      },
      async newRascunho () {
        if (!this.$route.params.id) {
          try {
            loader({ text: 'Gravando Rascunho do Registro', active: true })

            this.dados.registro.tipo_registro = this.dados.natimorto ? 'NT' : 'O'

            const rascunho = await RegistrosService.storeRascunho({ document: this.dados })
            this.dados = rascunho.document
            this.dados.rascunho_id = rascunho.rascunho_id

            await RegistrosService.updateRascunho(this.dados.rascunho_id, {document: this.dados})

            loader({ active: false })

            this.$toast.success('Rascunho salvo com sucesso!', {
              position: 'top-right',
              duration: 5000
            })

            await this.$router.push({name: 'editar_obito_rascunho_legado', params: {id: rascunho.rascunho_id}})

          } catch (error) {
            const message = getErrors(error)

            displayMessage('error', 'Erro!', message.message)

            setTimeout(() => {
              const btnConfirm = document.querySelector('.swal2-confirm')

              if (btnConfirm) btnConfirm.focus()
            }, 300)
          }
        }
      },

      async updateRascunho () {
        try {
          loader({ text: 'Atualizando Rascunho', active: true })

          await RegistrosService.updateRascunho(this.dados.rascunho_id, { document: this.dados })
          this.passoAtivo++

          loader({ active: false })
        } catch (err) {
          objSwal.error.title = 'Erro ao processar etapa'
          objSwal.error.text = err.message
          return Swal.fire(objSwal.error)
        }
      },

      async updateRegistro (registro) {
        this.dados.registro = { ...this.dados.registro, ...registro}

        await this.changed(this.dados)

        if (this.$route.params.id !== 'novo') {
          await RegistrosService.updateRascunho(this.dados.rascunho_id, {document: this.dados})
        }
      },

      async registerObito () {
        try {
          loader({ text: 'Cadastrando 2ª via do registro de Óbito', active: true })
          this.dados.cartorio_id = this.$store.state.auth.cartorio_id

          if (this.dados.numero_declaracao_obito) {
            this.dados.numero_declaracao_obito = this.dados.numero_declaracao_obito.replace('-', '').replace('-', '')
          } else {
            this.dados.numero_declaracao_obito = null
          }

          if (!this.dados.sem_declaracao_obito) this.dados.sem_declaracao_obito = false

          this.dados.registro.oficial = this.dadosCartorio.nome_oficial

          this.dados.pessoa = {
            cpf: this.dados.cpf,
            cpf_sem_inscricao: this.dados.cpf_sem_inscricao,
            nome: this.dados.nome,
            data_nascimento: this.dados.data_nascimento ? moment(String(this.dados.data_nascimento), 'DD/MM/YYYY').format('YYYY-MM-DD') : null,
            sexo: this.dados.sexo,
            cor_pele: this.dados.cor_pele,
            nacionalidade: this.dados.nacionalidade,
            nacionalidade_codigo: this.dados.nacionalidade_codigo,
            estado_civil: this.dados.estado_civil,
            ocupacao_codigo: this.dados.ocupacao_codigo,
            ocupacao_declarada: this.dados.ocupacao_declarada,
            naturalidade: this.dados.naturalidade,
            naturalidade_declarada: this.dados.naturalidade_declarada,
            uf: this.dados.uf,
            idade: this.dados.idade,
            pessoa_desconhecida: this.dados.pessoa_desconhecida,
            endereco: this.dados.endereco,
            documentos: this.dados.documentos,
            genitores: this.dados.genitores
          }

          const obito = await ObitoService.registrarObito(this.dados)

          objSwal.success.title = "Registro de 2º via  de Óbito cadastrado com sucesso"
          objSwal.success.text = ''
          objSwal.success.html = ''

          setTimeout(() => {
            const btnConfirm = document.querySelector('.swal2-confirm')

            if (btnConfirm) btnConfirm.focus()
          }, 300)

          loader({ text: "", active: false })

          return Swal.fire(objSwal.success).then(() => {
            this.$router.push({ name: 'resumo_obito', params: { id: obito.obito_id, propLegado: true } })
              .catch(() => {
                this.$router.push('/')
              })
          })
        } catch (error) {
          try {
            if (!error.response) {
              console.error(error)
              return this.displayError('TEXT', error)
            } else {
              if (Array.isArray(error.response.data)) {
                const messages = []

                error.response.data.forEach(resp => {
                  switch (resp.message) {
                  case 'unique validation failed on obito.numero_declaracao_obito':
                    messages.push(`A D.O ${this.dados.numero_declaracao_obito} já está vinculada à outro registro`)
                    break
                  case 'required validation failed on registro.oficial':
                    messages.push(`É necessário cadastrar o oficial no menu de serventia.`)
                    break
                  case 'sofia validation failed on obito.numero_declaracao_obito':
                    messages.push(`D.O Número ${this.dados.numero_declaracao_obito} não é válida.`)
                    break
                  }
                })

                const textSwal = `<ul>${messages.map(res => {
                  return `<li>${res}</li>`
                })}</ul>`

                const html = textSwal.replace(/\,/g,'')

                return this.displayError('HTML', html)
              }
              if (error.response.data.message && !error.response.data.message.message) {
                return this.displayError('TEXT', error.response.data.message).then(() => {
                  const msgs = [
                    'Configuração do Livro inválida!',
                    'Sequência do Livro inválida!',
                    'Sequências dos livros',
                    'Configurações dos livros'
                  ]

                  if (msgs.includes(error.response.data.message)) {
                    this.$router.push({ name: 'cadastro_serventia', params: { propConfigLivro: true }})
                  }
                })
              } else if (error.response.data && error.response.data.error && error.response.data.error.message) {
                if (error.response.data.error.message.match(/.*pessoa_cpf_unique.*/)) {
                  const duplicate = error.response.data.error.message.match(/Duplicate entry (.*)/)[1]
                  const cpf = duplicate.split(' ')[0]
                  return this.displayError('TEXT', `Já existe uma pessoa cadastrada com o cpf ${cpf}`)
                }
              }

              if (error.response.data && error.response.data.error) {
                return this.displayError('TEXT', error.response.data.error.message)
              }
            }
          } catch (error) {
            const text  = 'Houve algum erro ao cadastrar um novo registro de óbito, favor contactar o suporte.'

            return this.displayError('TEXT', text)
          }
          finally {
            loader({ text: '', active: false })
            delete objSwal.error.html
          }
        }
      },

      async changed (data) {
        this.dados = { ...data }

        const { rascunho_id, nome, cpf, cpf_sem_inscricao, tipo_registro_obito, pessoa_desconhecida } = this.dados

        if (!rascunho_id && nome && ((cpf || cpf_sem_inscricao) || (tipo_registro_obito === "NT" || pessoa_desconhecida))) {
          this.searchRascunho(data)
        }

        if (rascunho_id) {
          await RegistrosService.updateRascunho(this.dados.rascunho_id, { document: this.dados })
        }
      },

      invalids (list) {
        if (list.length) {
          list[0].scrollIntoView({ behavior: 'smooth', block: 'center', inline: "nearest" })
        }
      },
      async getCartorio () {
        this.dadosCartorio = this.$store.getters['auth/getCartorioObj']
      },
      documentoRemoved (documento) {
        this.dados.genitores.splice(documento.localId, 1)
      },
      displayError (type, message) {
        objSwal.error.title = 'Erro ao cadastrar'

        if (type === 'HTML') {
          objSwal.error.text = ''
          objSwal.error.html = message
        } else {
          objSwal.error.text = message
          objSwal.error.html = ''
        }

        loader({ text: '', active: false })

        return Swal.fire(objSwal.error)
      },
      verifyParte (parte) {
        this.parte = parte
      }
    }
  }
</script>

<style lang="scss">
@import '../../scss/_utilities/_exports';

.btn-danger {
  background-color: #8B0000;
  border-color: #8B0000
}

.btn-primary {
  background-color: #086AAE;
  border-color: #086AAE
}
</style>
